import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { MY_NOTES_ROUTE_KEY } from "../../platform_spaces/space/SpaceModel";
import { IS_STANDALONE } from "../../standalone/config";

/** 跳转「我的笔记」主页面；可选带上股票筛选 */
export function useMyNotesNavigate(spaceId: string) {
  const navigate = useNavigate();

  return useCallback(
    (stockCode?: string) => {
      const stock = stockCode?.trim();
      const q = stock ? `?stock=${encodeURIComponent(stock)}` : "";
      if (IS_STANDALONE) {
        navigate(`/tactik/my-notes${q}`);
        return;
      }
      navigate(`/space/${spaceId}/${MY_NOTES_ROUTE_KEY}${q}`);
    },
    [navigate, spaceId]
  );
}
